// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"talent-analytics_wrapper__1YozT","btn":"talent-analytics_btn__2pKta"};